// extracted by css-extract-rspack-plugin
export default {"cls1":"WinBackPing-cls1_GeZ","cls2":"WinBackPing-cls2_EnX WinBackPing-cls1_GeZ"};